
import React from 'react';
import BlogCard, { BlogCardProps } from './BlogCard';
import SectionHeading from '../ui/SectionHeading';
import { blogPosts } from './blogData';

const BlogGrid: React.FC = () => {
  // Sort blog posts by date (newest first)
  const sortedBlogPosts = [...blogPosts].sort((a, b) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });

  return (
    <div className="section-inner py-12">{/* Blog posts grid */}
      <SectionHeading 
        title="AI Insights & Trends"
        subtitle="Expert tips, industry updates, and practical guides on implementing AI for business efficiency and growth."
        centered
      />
      
      {/* Blog Collage Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {sortedBlogPosts.map((post, index) => {
          // Apply different styles based on position for a collage effect
          let className = "col-span-1";
          
          // Every 5th post spans 2 columns on larger screens
          if (index % 5 === 0) {
            className = "col-span-1 sm:col-span-2 lg:col-span-2";
          }
          
          // Every 8th post spans full width on larger screens
          if (index % 8 === 7) {
            className = "col-span-1 sm:col-span-2 lg:col-span-3";
          }
          
          return (
            <div key={index} className={className}>
              <BlogCard 
                title={post.title}
                excerpt={post.excerpt}
                date={post.date}
                author={post.author}
                slug={post.slug}
                image={post.coverImage || post.image}
                authorImage={post.author.avatar} // Pass author's avatar here
                coverImage={post.coverImage}
                category={post.category}
                readTime={post.readTime}
                featured={post.featured}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BlogGrid;
